import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SAManagement\GetCommandRunsController::__invoke
* @see app/Http/Controllers/SAManagement/GetCommandRunsController.php
* @route '/api/sa-management/command-runner/runs'
*/
const GetCommandRunsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCommandRunsController.url(options),
    method: 'get',
})

GetCommandRunsController.definition = {
    methods: ["get","head"],
    url: '/api/sa-management/command-runner/runs',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SAManagement\GetCommandRunsController::__invoke
* @see app/Http/Controllers/SAManagement/GetCommandRunsController.php
* @route '/api/sa-management/command-runner/runs'
*/
GetCommandRunsController.url = (options?: RouteQueryOptions) => {
    return GetCommandRunsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SAManagement\GetCommandRunsController::__invoke
* @see app/Http/Controllers/SAManagement/GetCommandRunsController.php
* @route '/api/sa-management/command-runner/runs'
*/
GetCommandRunsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetCommandRunsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SAManagement\GetCommandRunsController::__invoke
* @see app/Http/Controllers/SAManagement/GetCommandRunsController.php
* @route '/api/sa-management/command-runner/runs'
*/
GetCommandRunsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetCommandRunsController.url(options),
    method: 'head',
})

export default GetCommandRunsController